import {
    SYSTEMCONFIG_DELETE_SYSTEMCONFIG_BEGIN,
    SYSTEMCONFIG_DELETE_SYSTEMCONFIG_SUCCESS,
    SYSTEMCONFIG_DELETE_SYSTEMCONFIG_FAILURE,
    SYSTEMCONFIG_DELETE_SYSTEMCONFIG_DISMISS_ERROR,
  } from './constants';
  
  import request from '../../../utils/request'
  // Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
  // If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
  export function deleteSystemConfig(id) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: SYSTEMCONFIG_DELETE_SYSTEMCONFIG_BEGIN,
      });
  
      // Return a promise so that you could control UI flow without states in the store.
      // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
      // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
      // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
      const promise = new Promise((resolve, reject) => {
          request({
            method:'post',
            url:'/api/b/systemConfig/delete',
            data:{id:id}
          }).then( data => {
              dispatch({
                  type: SYSTEMCONFIG_DELETE_SYSTEMCONFIG_SUCCESS,
              });
              resolve(data);
          }).catch (error => {
              dispatch({
                type: SYSTEMCONFIG_DELETE_SYSTEMCONFIG_FAILURE,
                data: { error: error },
              });
              reject(error);
          })
      });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissDeleteSystemConfigError() {
    return {
      type: SYSTEMCONFIG_DELETE_SYSTEMCONFIG_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case SYSTEMCONFIG_DELETE_SYSTEMCONFIG_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          deleteSystemConfigPending: true,
          deleteSystemConfigError: null,
        };
  
      case SYSTEMCONFIG_DELETE_SYSTEMCONFIG_SUCCESS:
        // The request is success
        return {
          ...state,
          deleteSystemConfigPending: false,
          deleteSystemConfigError: null,
        };
  
      case SYSTEMCONFIG_DELETE_SYSTEMCONFIG_FAILURE:
        // The request is failed
        return {
          ...state,
          deleteSystemConfigPending: false,
          deleteSystemConfigError: action.data.error,
        };
  
      case SYSTEMCONFIG_DELETE_SYSTEMCONFIG_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          deleteSystemConfigError: null,
        };
  
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/features/systemconfig/redux/deleteSystemConfig.js